<template>
    <div>
        <v-row justify="center" align="stretch">
            <v-col cols="12" lg="12" xl="12">
                <transition name="fade">
                    <v-card>
                        <v-card-title>
                            <span class="body-2">
                                <v-icon left>mdi-chart-bar</v-icon>
                                {{ chartTitle1 }}
                            </span>

                            <v-spacer></v-spacer>

                            <v-btn icon @click="card1 = !card1">
                                <v-icon>
                                    {{ card1 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
                                </v-icon>
                            </v-btn>
                        </v-card-title>

                        <v-divider v-show="card1"></v-divider>

                        <v-expand-transition>
                            <div v-show="card1">
                                <v-card-text>
                                    <apexchart
                                        type="bar"
                                        height="1500"
                                        :options="chartOptions1"
                                        :series="series1"
                                    />
                                </v-card-text>
                            </div>
                        </v-expand-transition>
                    </v-card>
                </transition>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { EventBus } from '@/main.js'
import VueApexCharts from 'vue-apexcharts'

    export default {
        name: 'maintennce-schedule-entrances',

        components: {
            apexchart: VueApexCharts,
        },

        data: () => ({
            loading: false,
            card1: false,
            card2: false,
            chartData: [],
            chartTitle1: "Maintenance schedule (In progress)",
            parameters: null,
            entrances: [],
            interval1 : null,

            series1: [{
                data: [],
            }],
          chartOptions1: {
            chart: {
              type: 'bar',
              height: 1500
            },
            colors: [ ({ value }) => value <= 7000 ? '#2E7D32' // zelena
                       : value <= 9000 ? '#FB8C00' // oranzna
                       : '#C62828' ], // rdeca
            plotOptions: {
              bar: {
                borderRadius: 4,
                horizontal: true,
                dataLabels: {
                    position: 'top',
                },
              }
            },
            dataLabels: {
              enabled: true,
              formatter: function (val) {
                    return val.toLocaleString('sl-SI');
                },
                textAnchor: 'start',
                offsetX: 8,
                style: {
                    fontSize: '13px',
                    fontWeight: 'bold',
                    colors: ['#fff'],
                },
            },
            xaxis: {
              categories: [/*'South Korea', 'Canada', 'United Kingdom', 'Netherlands', 'Italy', 'France', 'Japan',
                'United States', 'China', 'Germany','South Korea', 'Canada', 'United Kingdom', 'Netherlands', 'Italy', 'France', 'Japan',
                'United States', 'China', 'Germany','South Korea', 'Canada', 'United Kingdom', 'Netherlands', 'Italy', 'France', 'Japan',
                'United States', 'China', 'Germany'*/
              ],
            },

            tooltip: {
                fixed: {
                    enabled: false,
                },
                x: {
                    show: true,
                },
                y: {
                    title: {
                    formatter: function (seriesName) {
                        return 'Entrances:';
                    },
                    },
                },
                marker: {
                    show: false,
                },
            }
          },
        }),

        watch: {
            card1: {
                handler(value) {
                    //window.console.log("Telemetry card1: " + value)
                    this.$store.commit("APP_SETTING", {
                        setting: "maintenance_schedule_entrances",
                        key: "card1",
                        value: value
                    })
                },

                //immediate: true
            },
        },

        computed: {
            getChartData() {
                return this.chartData
            }
        },

        methods: {
            fetchData() {

                window.console.log("### MaintenanceScheduleEntrances@fetchData ###")
                //window.console.log(this.parameters)

                let vm = this
                vm.loading = true;
                this.$store.dispatch('MAINTENANCE_SCHEDULE_ENTRANCES_DATA', vm.parameters)
                //this.$store.dispatch('ENTRANCES_DATA', vm.parameters)
                .then(response => {
                    //window.console.log("fetchData")
                    //window.console.log(response.data)
                    vm.entrances = response.data.entrances
                    vm.drawMaintenanceScheduleEntrancesChart()
                })
                .catch(err => {
                    window.console.error(err)
                })
                .finally(() => {
                    vm.loading = false
                })
            },

            drawMaintenanceScheduleEntrancesChart() {
                // 1) dinamična višina
                const count = this.entrances.length;
                const height =
                    count < 5
                    ? 300
                    : Math.min(2000, 80 + count * 36); // ~36px na vrstico + malo paddinga

                const names = [];
                const values = [];
                const longNames = [];

                const now = new Date();
                const month = now.getMonth() + 1; // 1-12

                // sezona poletje: od junija do septembra
                const isSummer = month >= 6 && month < 9

                const greenLimit = isSummer ? 6500 : 7000;
                const yellowLimit = isSummer ? 8000 : 9000;

                this.entrances.slice(0, 200).forEach(item => {
                    names.push(String(item.name || ''));
                    values.push(Number(item.value || 0));
                    longNames.push(String(item.name_long || item.name || ''));
                });

                this.series1 = [{ data: values }];

                // ključ: ustvari NOV objekt, ne mutiraj obstoječega
                this.chartOptions1 = {
                    ...this.chartOptions1,
                    xaxis: { ...(this.chartOptions1.xaxis || {}), categories: names}, // z prikaz samo spodaj
                    yaxis: { labels: { show: true } }, // za vsak slučaj
                    /*yaxis: {
                        ...(this.chartOptions1.yaxis || {}),
                        labels: {
                            ...((this.chartOptions1.yaxis || {}).labels || {}),
                            show: true,
                            minWidth: 200,
                            maxWidth: 500,
                        },
                    },*/
                    chart: { ...(this.chartOptions1.chart || {}), height },
                    tooltip: {
                        ...(this.chartOptions1.tooltip || {}),

                        x: {
                            formatter: (value, { dataPointIndex }) => {
                                return longNames[dataPointIndex] || value;
                            },
                        },

                        y: {
                            title: {
                                formatter: function () {
                                    return 'Entrances:';
                                },
                            },
                        },

                        marker: {
                            show: false,
                        },
                    },

                    dataLabels: {
                        enabled: true,
                        formatter: function (val) {
                            return Number(val).toLocaleString('sl-SI');
                        },
                        textAnchor: this.$vuetify.breakpoint.xsOnly ? 'start' : 'middle',
                        offsetX: this.$vuetify.breakpoint.xsOnly ? 0 : -10,
                        style: {
                            fontSize: '12px',
                            fontWeight: 'bold',
                            colors: [
                                this.$vuetify.breakpoint.xsOnly ? '#000' : '#fff'
                            ],
                        },
                    },

                    colors: [
                        ({ value }) =>
                            value <= greenLimit
                                ? '#2E7D32'
                                : value <= yellowLimit
                                    ? '#FB8C00'
                                    : '#C62828'
                    ],
                };
            }
        },

        created() {
            let vm = this
            vm.card1 = vm.$store.getters.appSettings.maintenance_schedule_entrances.card1
            vm.card2 = vm.$store.getters.appSettings.maintenance_schedule_entrances.card2

            this.fetchData()  

            vm.interval1 = setInterval(() => {
                vm.fetchData()
            }, process.env.VUE_APP_DATA_TABLES_REFRESH_INTERVAL || 180000)
        },

        mounted() {
            let vm = this;
            EventBus.$on('maintenance-schedule-entrances', (data) => {
            //window.console.log(data);

            vm.parameters = data;

            vm.fetchData();

            /*
            let payload = data

            if(payload.parameters.startDate !== payload.parameters.endDate) {
              vm.chartTitle1 = "Entrances since last maintenance (" + payload.parameters.startDate + " - " + payload.parameters.endDate +")"
            } else {
              vm.chartTitle1 = "Entrances since last maintenance - " + payload.parameters.startDate +  " (" + payload.parameters.startTime + " - " + payload.parameters.endTime +")"
            }
            */
            })
            
        },

        beforeDestroy() {
            EventBus.$off('maintenance-schedule-entrances'); 
            clearInterval(this.interval1)
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition-property: opacity;
        transition-duration: .25s;
    }

    .fade-enter-active {
        transition-delay: .25s;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0
    }
</style>

